import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';

const NotFound: React.FC = () => {
  return (
    <Container className="d-flex align-items-center justify-content-center vh-100 text-center">
      <Row>
        <Col>
          <h1 className="display-3 fw-bold">404</h1>
          <p className="lead">Oops! The page you’re looking for doesn’t exist.</p>
          <Button variant="primary" as={Link as any} to="/">
            Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
